import { format } from 'react-string-format';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink } from '../../ui-elements/MyMLink';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MyMLink } from '../../ui-elements/MyMLink';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { Box, Grid, CardContent, Stack, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

/** MyMine Version12.0 SpecializedPartsServiceLv1画面新規追加
* SpecializedPartsServiceLv1 Page Content
*/
export const SpecializedPartsServiceLv1 = () => {
  const screenId = 'MyM306';
  const { controlSettings } = useWebContext(screenId);
  const navigate = useNavigate();
  const apiRequest = useMyMApi(screenId);
  const [isInitLoading, setIsInitLoading] = useState(true);
  const isPc = useMediaQuery(mediaQuery.pc);
  const isSmallScreen = useMediaQuery('(max-width: 390px)');  // 390px以下の画面幅を検出

  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);
    apiRequest.requestJson('api/specialized-parts-service/lv1', 'GET', endLoading, endLoading);
  }, [])

  if (isInitLoading)
    return <MyMProgress />

  const SectionLabel = (props) => <MyMVariantLabel variant='h4' className='fs-3 fw-bolder text-start'>{props.children}</MyMVariantLabel>

  const spsLv1ContentsComponents =
    [
      // Bradken
      {
        headerImage: `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgBradken2}`,
        imageHeight: 120,  // 390px以下の画面での画像の高さ
        introductionText:
          format(controlSettings.LabelList.lblBradkenIntroduction,
            <span className='fs-6'>{controlSettings.LabelList.lblBradkenIntroductionCompanyName}</span>),
        sectionList:
          [
            {
              additionalContent: (
                <>
                  <MyMLabel>{controlSettings.LabelList.lblBradkenOverview2}</MyMLabel>
                  <MyMLabel>
                    <MyMVariantLabel fontWeight='bold' component='span'>{controlSettings.LabelList.lblBradkenOverview2_1}</MyMVariantLabel>
                    {controlSettings.LabelList.lblBradkenOverview2_2}
                  </MyMLabel>
                  <MyMLabel>
                    <MyMVariantLabel fontWeight='bold' component='span'>{controlSettings.LabelList.lblBradkenOverview2_3}</MyMVariantLabel>
                    {controlSettings.LabelList.lblBradkenOverview2_4}
                  </MyMLabel>
                  <MyMLabel>
                    <MyMVariantLabel fontWeight='bold' component='span'>{controlSettings.LabelList.lblBradkenOverview2_5}</MyMVariantLabel>
                    {controlSettings.LabelList.lblBradkenOverview2_6}
                  </MyMLabel>
                  <MyMImage
                    screenId={screenId}
                    filePath={controlSettings.ImageList.imgBradkenLocation2}
                    alt="Bradken Location2"
                    height={isSmallScreen ? "200px" : "294px"}
                    width="100%"
                  />
                  <MyMLabel>
                    {format(
                      controlSettings.LabelList.lblBradkenLocation2,
                      <b style={{ fontSize: isSmallScreen ? '24px' : '30px' }}>{controlSettings.LabelList.lblBradkenLocation1}<br /></b>
                    )}
                    <MyMLink onClick={() => window.open(controlSettings.UrlList.lnkBradkenLocation, '_blank')}>
                      {controlSettings.LabelList.lblBradkenLocation3}
                    </MyMLink>
                  </MyMLabel>
                  <br />
                </>
              ),
              uiBaseKey: 'BradkenOverview',
            },
            {
              linkAction: () => navigate('/MyM102/MyM306/MyM307', { state: { scrollMode: true } }),
              uiBaseKey: 'BradkenProductsAndSolutions',
            },
            {
              linkAction: () => window.open(controlSettings.UrlList.urlBradkenGlobalContactInformation, '_blank'),
              uiBaseKey: 'BradkenGlobalContactInformation',
            }
          ],
      },
      // H-E Parts
      {
        headerImage: `${process.env.PUBLIC_URL}/${screenId}/${controlSettings.ImageList.imgKeySolutions62}`,
        imageHeight: 100,  // 390px以下の画面での画像の高さ
        introductionText:
          format(controlSettings.LabelList.lblHEPartsIntroduction,
            <span className='fs-6'>{controlSettings.LabelList.lblHEPartsIntroductionCompanyName}</span>),
        sectionList:
          [
            {
              additionalContent: (
                <>
                  <MyMLabel>{controlSettings.LabelList.lblHEPartsOverview}</MyMLabel>
                  <MyMLabel>
                    <MyMVariantLabel fontWeight='bold' component='span'>{controlSettings.LabelList.lblHEPartsOverview_1}</MyMVariantLabel>
                    {controlSettings.LabelList.lblHEPartsOverview_2}
                  </MyMLabel>
                  <MyMLabel>
                    <MyMVariantLabel fontWeight='bold' component='span'>{controlSettings.LabelList.lblHEPartsOverview_3}</MyMVariantLabel>
                    {controlSettings.LabelList.lblHEPartsOverview_4}
                  </MyMLabel>
                  <MyMLabel>
                    <MyMVariantLabel fontWeight='bold' component='span'>{controlSettings.LabelList.lblHEPartsOverview_5}</MyMVariantLabel>
                    {controlSettings.LabelList.lblHEPartsOverview_6}
                  </MyMLabel>
                  <MyMImage
                    screenId={screenId}
                    filePath={controlSettings.ImageList.imgHepartsLocation}
                    alt="HE Parts Location"
                    height={isSmallScreen ? "190px" : "294px"}
                    width="100%"
                  />
                  <MyMLabel>
                    {format(
                      controlSettings.LabelList.lblHEPartsLocation22,
                      <b style={{ fontSize: isSmallScreen ? '24px' : '30px' }}>{controlSettings.LabelList.lblHEPartsLocation12}<br /></b>
                    )}
                    <MyMLink onClick={() => window.open(controlSettings.UrlList.lnkHEPartsLocation2, '_blank')}>
                      {controlSettings.LabelList.lblHEPartsLocation32}
                    </MyMLink>
                  </MyMLabel>
                  <br />
                </>
              ),
              uiBaseKey: 'HEPartsOverview',
            },
            {
              linkAction: () => navigate('/MyM102/MyM306/MyM308', { state: { scrollMode: true } }),
              uiBaseKey: 'HEPartsProductsAndSolutions',
            },
            {
              linkAction: () => window.open(controlSettings.UrlList.urlHEPartsGlobalContactInformation, '_blank'),
              uiBaseKey: 'HEPartsGlobalContactInformation',
            }
          ],
      },
    ];

  return (
    <Box className='py-1'>
      <Box>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblSpecializedPartsServiceLv1Title}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblSpecializedPartsServiceLv1Massage}</MyMLabel>
      </Box>
      <Grid
        container
        className='mt-2 pb-2'
        sx={{
          px: isPc ? 20 : 0,
          width: '100%'
        }}
        columnSpacing={isPc ? 8 : 0}
      >
        {spsLv1ContentsComponents.map((contentsComponent, i) =>
          <Grid key={i} item xs={12} md={6} >
            <CardContent>
              <Stack spacing={1}>
                <CardMedia
                  component="img"
                  height={isSmallScreen ? contentsComponent.imageHeight : 160}  // 画面サイズに応じて高さを調整
                  image={contentsComponent.headerImage}
                  sx={{ objectFit: 'contain' }}  // 画像比率を維持
                />
                <MyMLabel>{contentsComponent.introductionText}</MyMLabel>
                <br />
                <MyMLabel style={{ fontWeight: 'bold', fontSize: isSmallScreen ? '1.5rem' : '2rem' }}>
                  {controlSettings.LabelList.lblBradkenCompanyOverview}
                </MyMLabel>
                {contentsComponent.sectionList.map(section =>
                  <Box key={section.uiBaseKey}>
                    <MyMBlackLink onClick={section.linkAction} className='d-flex flex-column mb-2' >
                      <SectionLabel>{controlSettings.LabelList[`lnk${section.uiBaseKey}`]}</SectionLabel>
                    </MyMBlackLink>
                    {section.additionalContent}
                  </Box>
                )}
              </Stack>
            </CardContent>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default SpecializedPartsServiceLv1;
